import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum TeamSurveyDetailsReportFields {
  surveyId = 'surveyId',
  templateId = 'templateId',
  surveyName = 'surveyName',
  surveyStatus = 'surveyStatus',
  surveyResponseId = 'surveyResponseId',
  submissionDate = 'submissionDate',
  sentDate = 'sentDate',
  teamId = 'teamId',
  teamName = 'teamName',
  teamStartDate = 'teamStartDate',
  teamEndDate = 'teamEndDate',
  teamCustomFields = 'teamCustomFields',
  responses = 'responses',
  personId = 'personId',
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  isAnonymous = 'isAnonymous',
}

export const TeamSurveyDetailsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(TeamSurveyDetailsReportFields.surveyResponseId, '', 'Response Id'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.templateId, '', 'Template Id'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.surveyName, '', 'Survey Name'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.surveyStatus, '', 'Survey Status'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.sentDate, '', 'Sent Date'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.submissionDate, '', 'Submission Date'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.teamId, '', 'Team Id'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.teamStartDate, '', 'Team Start Date'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.teamEndDate, '', 'Team End Date'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.personId, '', 'PersonId'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.email, '', 'Email'),
  new ItemPickerModel(TeamSurveyDetailsReportFields.isAnonymous, '', 'Survey Anonymity'),
];
